/* eslint-disable no-param-reassign */

xplenty.directive('dateRange', [
  function () {
    return {
      restrict: 'E',

      // eslint-disable-next-line global-require
      template: require('./date-range.html'),

      replace: true,

      scope: {
        startDate: '=',
        endDate: '=',
        startFieldName: '@?',
        endFieldName: '@?',
        format: '=',
      },

      link(scope, element) {
        const $dateRangeControl = element.find('.date-range-form-control');

        let startDate = moment(scope.startDate);
        if (!startDate.isValid()) {
          startDate = moment().subtract(7, 'days');
        }

        let endDate = moment(scope.endDate);
        if (!endDate.isValid()) {
          endDate = moment();
        }

        function dispatchEvents() {
          element.find('.start-date')[0].dispatchEvent(
            new Event('input', {
              bubbles: true,
              cancelable: true,
            }),
          );
          element.find('.end-date')[0].dispatchEvent(
            new Event('input', {
              bubbles: true,
              cancelable: true,
            }),
          );
        }

        $dateRangeControl.daterangepicker(
          {
            locale: {
              format: 'll',
            },
            parentEl: element,
            autoApply: true,
            alwaysShowCalendars: true,
            startDate: startDate.format(scope.format || 'll'),
            endDate: endDate.format(scope.format || 'll'),
          },
          function (start, end) {
            startDate = start;
            endDate = end;
            scope.startDate = start.format(scope.format || 'll');
            scope.endDate = end.format(scope.format || 'll');
            scope.$apply();
            dispatchEvents();
          },
        );

        scope.setStartDate = function () {
          const startDateValue = moment(scope.startDate);
          if (startDateValue.isValid()) {
            startDate = startDateValue;
            scope.startDate = startDate.format(scope.format || 'll');
          }
        };

        scope.setEndDate = function () {
          const endDateValue = moment(scope.endDate);
          if (endDateValue.isValid()) {
            endDate = endDateValue;
            scope.endDate = endDate.format(scope.format || 'll');
          }
        };
      },
    };
  },
]);
